<!-- SPlayer's existing catalog adapters own pagination, account cloud contents,
     errors, route state and cancellation. See SPlayerExplore.vue for AGPL-3.0
     attribution. This component provides the Apple page hierarchy. -->
<template>
  <section v-if="view === 'cloud'" class="apple-page apple-cloud" aria-label="我的云盘" data-apple-cloud>
    <AppleCloudPanel />
  </section>
  <section v-else class="apple-page apple-explore" aria-label="在线音乐" data-apple-explore :data-apple-online-tab="activeTab">
    <ApplePageHeader class="apple-explore-heading" title="发现" subtitle="发现新的音乐与歌单。">
      <AppleSegmentedControl v-if="activeTab === 'playlists'" class="apple-platform-switch" aria-label="内容平台" :value="catalogSettings.platform" :options="platformOptions" @input="selectPlatform"><template #option="{option}"><img class="apple-platform-icon" :src="option.value === 'tx' ? qqMusicIcon : neteaseMusicIcon" alt=""/>{{ option.label }}</template></AppleSegmentedControl>
    </ApplePageHeader>
    <nav ref="onlineTabs" class="apple-online-tabs" role="tablist" aria-label="在线音乐分类" @keydown="moveTab">
      <button v-for="tab in tabs" :id="'online-tab-' + tab.id" :key="tab.id" type="button" role="tab" :data-online-tab="tab.id" :aria-selected="String(activeTab === tab.id)" :tabindex="activeTab === tab.id ? 0 : -1" aria-controls="online-tab-panel" @click="selectTab(tab.id)">{{ tab.label }}</button>
    </nav>
    <div id="online-tab-panel" class="apple-catalog-panel" role="tabpanel" :aria-labelledby="'online-tab-' + activeTab">
      <component :is="activeComponent" :key="activeTab + ':' + catalogSettings.platform" class="apple-catalog-feed" />
    </div>
  </section>
</template>
<script>
import SPlayerExplore from '../salt/SPlayerExplore.vue';
import AppleDiscoverPlaylists from './AppleDiscoverPlaylists.vue';
import AppleDiscoverToplists from './AppleDiscoverToplists.vue';
import AppleDiscoverNew from './AppleDiscoverNew.vue';
import AppleDiscoverArtists from './AppleDiscoverArtists.vue';
import AppleCloudPanel from './AppleCloudPanel.vue';
import ApplePageHeader from './ui/ApplePageHeader.vue';
import AppleSegmentedControl from './ui/AppleSegmentedControl.vue';
import qqMusicIcon from './assets/qq-music.png';
import neteaseMusicIcon from './assets/netease-music.png';
import './apple-pages.scss';
import './apple-explore.scss';
import './apple-explore-reference.scss';
import './apple-discover-readability.scss';
export default {
  name: 'AppleExplore', extends: SPlayerExplore, components: { ApplePageHeader, AppleSegmentedControl, AppleCloudPanel },
  data(){return {qqMusicIcon,neteaseMusicIcon};},
  computed: {
    platformOptions() { return this.platforms.map(platform => ({ value: platform.id, label: platform.name })); },
    activeComponent() {
      return { playlists: AppleDiscoverPlaylists, toplists: AppleDiscoverToplists, artists: AppleDiscoverArtists, new: AppleDiscoverNew }[this.activeTab] || this.tabs.find(tab => tab.id === this.activeTab).component;
    },
  },
};
</script>
<style scoped>
.apple-platform-switch ::v-deep .apple-segmented-option { display:inline-flex; align-items:center; gap:6px; }
.apple-platform-icon { width:14px; height:14px; flex:none; border-radius:3px; object-fit:contain; }
</style>
